import { render, staticRenderFns } from "./bi-select.vue?vue&type=template&id=1ec91490&"
import script from "./bi-select.vue?vue&type=script&lang=ts&"
export * from "./bi-select.vue?vue&type=script&lang=ts&"
import style0 from "./bi-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports